import { Box, Button, Grid, IconButton } from "@material-ui/core";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import React from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../../inputComponent/CustomTextField/CustomTextField";

export default function LocationAndItemFields({
    classes,
    control,
    register,
    errors,
    exerciseIndex,
    getValues,
}) {
    const { t, i18n } = useTranslation();

    const { fields, remove, append } = useFieldArray({
        control,
        name: `exercise.${exerciseIndex}.location`,
    });
    const itemFieldArray = useFieldArray({
        control,
        name: `exercise.${exerciseIndex}.item`,
    });
    return (
        <>
            <Grid container>
                <Grid item xs={3} className={classes.label}>
                    {t("Form100.label.location")}
                </Grid>

                <Grid item xs={6}>
                    {fields.map((location, locationIndex) => {
                        return (
                            <Box
                                display={"flex"}
                                key={locationIndex}
                                style={{ position: "relative" }}
                            >
                                <CustomTextField
                                    inputProps={{
                                        ...register(
                                            `exercise.${exerciseIndex}.location.${locationIndex}.enText`,
                                            {
                                                required:
                                                    t("errorMsg.required"),
                                            }
                                        ),
                                        autoComplete: "off",
                                    }}
                                    placeholder={t(`common.en`)}
                                    style={{
                                        marginRight: "10px",
                                    }}
                                    error={
                                        errors?.exercise?.[exerciseIndex]
                                            ?.location?.[locationIndex]?.enText
                                    }
                                />
                                <CustomTextField
                                    inputProps={{
                                        ...register(
                                            `exercise.${exerciseIndex}.location.${locationIndex}.scText`,
                                            {
                                                required:
                                                    t("errorMsg.required"),
                                            }
                                        ),
                                        autoComplete: "off",
                                    }}
                                    placeholder={t(`common.sc`)}
                                    style={{
                                        marginRight: "10px",
                                    }}
                                    error={
                                        errors?.exercise?.[exerciseIndex]
                                            ?.location?.[locationIndex]?.scText
                                    }
                                />
                                <CustomTextField
                                    inputProps={{
                                        ...register(
                                            `exercise.${exerciseIndex}.location.${locationIndex}.tcText`,
                                            {
                                                required:
                                                    t("errorMsg.required"),
                                            }
                                        ),
                                        autoComplete: "off",
                                    }}
                                    placeholder={t(`common.tc`)}
                                    error={
                                        errors?.exercise?.[exerciseIndex]
                                            ?.location?.[locationIndex]?.tcText
                                    }
                                />
                                {locationIndex !== 0 && (
                                    <IconButton
                                        color="primary"
                                        onClick={() => {
                                            remove(locationIndex);
                                            itemFieldArray.remove(
                                                locationIndex
                                            );
                                        }}
                                        style={{
                                            position: "absolute",
                                            right: "-45px",
                                            top: "-5px",
                                        }}
                                    >
                                        <RemoveCircleIcon />
                                    </IconButton>
                                )}
                            </Box>
                        );
                    })}

                    {/* {fields.length < 5 && (
                        <Box mt={fields.length ? 2 : 4}>
                            <Button
                                onClick={() => {
                                    append(
                                        { enText: "", scText: "", tcText: "" },
                                        { shouldFocus: false }
                                    );
                                    itemFieldArray.append(
                                        { text: "" },
                                        { shouldFocus: false }
                                    );
                                }}
                                variant="contained"
                                color="primary"
                            >
                                {t("common.button.append")}
                            </Button>
                        </Box>
                    )} */}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={3} className={classes.label}>
                    {t("Form100.label.locationItemNo") + t("common.colon")}
                </Grid>
                <Grid item xs={6}>
                    {itemFieldArray.fields.map((item, itemIndex) => {
                        return (
                            <>
                                <CustomTextField
                                    inputProps={{
                                        ...register(
                                            `exercise.${exerciseIndex}.item.${itemIndex}.text`,
                                            {
                                                required:
                                                    t("errorMsg.required"),
                                                validate: {
                                                    repeatData: (text) => {
                                                        const itemArr =
                                                            getValues(
                                                                `exercise.${exerciseIndex}.item`
                                                            );
                                                        const repeatItem =
                                                            itemArr.filter(
                                                                (item) =>
                                                                    item.text ===
                                                                    text
                                                            );
                                                        return (
                                                            repeatItem.length <=
                                                                1 ||
                                                            t(
                                                                "Form100.errorMsg.repeatData",
                                                                {
                                                                    item: t(
                                                                        "Form100.label.item"
                                                                    ).slice(
                                                                        0,
                                                                        -1
                                                                    ),
                                                                }
                                                            )
                                                        );
                                                    },
                                                },
                                            }
                                        ),
                                        autoComplete: "off",
                                    }}
                                    error={
                                        errors?.exercise?.[exerciseIndex]
                                            ?.item?.[itemIndex]?.text
                                    }
                                    fullWidth
                                />
                                {/* {itemIndex !== 0 && (
                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        remove(itemIndex);
                                    }}
                                >
                                    <RemoveCircleIcon />
                                </IconButton>
                            )} */}
                            </>
                        );
                    })}
                    {fields.length < 5 && (
                        <Box mt={fields.length ? 2 : 4}>
                            <Button
                                onClick={() => {
                                    append(
                                        { enText: "", scText: "", tcText: "" },
                                        { shouldFocus: false }
                                    );
                                    itemFieldArray.append(
                                        { text: "" },
                                        { shouldFocus: false }
                                    );
                                }}
                                variant="contained"
                                color="primary"
                            >
                                {t("common.button.append")}
                            </Button>
                        </Box>
                    )}
                </Grid>
            </Grid>
        </>
    );
}
